'use strict';/* global define */define('modules/users/directives/user-list-user/controller',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
     controller.$inject = ["$scope"];
function controller($scope){// jshint validthis:true
// jshint latedef:false
var ctrl=this;ctrl.close=closeIt;// ---
/**
     * Call via $scope provided close function
     * and set busy flag if request object is returned
     *
     * @param  {Object} ev   - triggered event
     * @param  {Object} user - user
     *
     * @tested
     */function closeIt(ev,user){var request=$scope.close(ev,user);if(request&&!!request.$promise){$scope.busy=true;request.$promise.finally(function(){$scope.busy=false;});}}}module.exports=controller;});
